import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ResizablePanel } from '@/components/resizable-panel'
import PlaybookSidebar from '../../features/playbook/components/playbook-sidebar'
import { PlaybookPendingComponent } from '../../features/playbook/components/playbook-pending'
import { intentBreakdownLoader } from '../../features/playbook/apis'
import { DEFAULT_ORGANIZATION_ID } from '../../features/playbook/components/overview/channel-filter'

type PlaybookSearch = {
    organizationId?: number
}

export const Route = createFileRoute('/_app/playbook')({
    validateSearch: (search: Record<string, unknown>): PlaybookSearch => {
        return {
            organizationId: search.organizationId ? Number(search.organizationId) : DEFAULT_ORGANIZATION_ID,
        }
    },
    loaderDeps: ({ search }) => ({
        organizationId: search.organizationId ?? DEFAULT_ORGANIZATION_ID,
    }),
    loader: async ({ deps, context }) => {
        return intentBreakdownLoader(context.queryClient, context.api, deps.organizationId);
    },
    pendingComponent: PlaybookPendingComponent,
    component: () => (
        <div className="flex h-full flex-row">
            <ResizablePanel
                defaultWidth={260}
                minWidth={200}
                maxWidth={700}
                handlePosition="right"
            >
                <PlaybookSidebar />
            </ResizablePanel>
            <div className="flex-1 min-w-0 overflow-auto bg-background">
                <Outlet />
            </div>
        </div>
    ),
})
